import { useConverter } from "./useConverter";

interface AudioConverterProps {
  file: File | null;
}

export function AudioConverter({ file }: AudioConverterProps) {
  const convState = useConverter(file);

  if (convState.status === "idle") return null;

  return (
    <div className="mt-6 flex flex-col items-center gap-3">
      {convState.status === "encoding" && (
        <div className="flex items-center gap-2 text-[#3dd8c0]/70 text-sm">
          <Spinner />
          Encoding to MP3…
        </div>
      )}

      {convState.status === "done" && (
        <a
          href={convState.url}
          download="recording.mp3"
          className="flex items-center gap-2 px-5 py-2 rounded-full border border-[#3dd8c0]/40 text-[#3dd8c0] text-sm hover:bg-[#3dd8c0]/10 transition-colors"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="15"
            height="15"
          >
            <path d="M12 3v12M7 14l5 5 5-5" />
            <path d="M5 21h14" />
          </svg>
          Download MP3
        </a>
      )}

      {convState.status === "error" && (
        <p className="text-red-400/80 text-sm">{convState.message}</p>
      )}
    </div>
  );
}

function Spinner() {
  return (
    <svg
      className="animate-spin"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
    >
      <path
        d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"
        strokeLinecap="round"
      />
    </svg>
  );
}
